import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIFetchRequestOptions } from '@sondermind/utilities/models-http';
import { snakeCaseTransformer } from '@sondermind/utilities/tools';
import { ISocialIntakeApiContract, ISocialIntakeApiResponse } from '../models/social-intake-form.model';
import { IQuickLeadIntakeApiContract } from '../models/quick-lead-intake-form.model';

@Injectable({
  providedIn: 'root'
})
export class QuickLeadIntakeHttpService {
  constructor(
    private httpService: HttpService,
    private configurationService: ConfigurationService
  ) {}

  submitQuickLeadIntake$(
    body: IQuickLeadIntakeApiContract,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<null> {
    const apiUrl = `${this.configurationService.env.dataExchangeSvcBase ?? ''}/public/v1/referrals/direct`;
    const params = this.httpService.generateFetchParams(opts);

    return this.httpService.post<null>(apiUrl, snakeCaseTransformer(body), params).pipe(
      this.httpService.handleHttpErrorStrict()
    );
  }

  createReferralRequest$(
    body: ISocialIntakeApiContract,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<ISocialIntakeApiResponse | null> {
    const apiUrl = `${this.configurationService.env.dataExchangeSvcBase ?? ''}/public/v1/referral_requests/direct`;
    const params = this.httpService.generateFetchParams(opts);

    return this.httpService.post<ISocialIntakeApiResponse>(apiUrl, snakeCaseTransformer(body), params).pipe(
      this.httpService.handleHttpErrorStrict()
    );
  }
}
